import { Box, useTheme, useMediaQuery, Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  ActionIconButton,
} from '../../../../common/components';
import { getLotStatusLabel } from '../utils/lotsUtils';

const LotsTableView = ({
  data,
  isLoading,
  onEdit,
  onDelete,
  LoadingComponent,
  projectsMap,
  canEditLots = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <GeneralTableBox>
        {isLoading ? (
          <LoadingComponent />
        ) : data && data.length > 0 ? (
          <Box sx={{ p: 2 }}>
            {data.map((lot) => (
              <Box
                key={lot.uuid}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  p: 2,
                  mb: 2,
                  backgroundColor: 'white',
                }}
              >
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mb: 2 }}>
                  <Box>
                    <strong>Lote:</strong> {lot.lot_number}
                  </Box>
                  <Box>
                    <strong>Manzana:</strong> {lot.block_number || '-'}
                  </Box>
                  <Box>
                    <strong>Catastro:</strong> {lot.cadastral_number || '-'}
                  </Box>
                  <Box>
                    <strong>Proyecto:</strong> {projectsMap[lot.uuid]?.name || '-'}
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                  <ActionIconButton
                    variant="edit"
                    onClick={() => onEdit(lot)}
                    disabled={!canEditLots}
                  />
                  <ActionIconButton
                    variant="delete"
                    onClick={() => onDelete(lot)}
                    disabled={!canEditLots}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <NoDataSkeleton colSpan={1} message="No se encontraron lotes" />
        )}
      </GeneralTableBox>
    );
  }

  return (
    <GeneralTableBox>
      <Table aria-label="lots table">
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="15%">Lote</HeadTableCell>
            <HeadTableCell wmd="15%">Manzana</HeadTableCell>
            <HeadTableCell wmd="20%">Catastro</HeadTableCell>
            <HeadTableCell wmd="20%">Proyecto</HeadTableCell>
            <HeadTableCell wmd="15%">Estado</HeadTableCell>
            <HeadTableCell wmd="15%">Acciones</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((lot) => (
              <TableRow key={lot.uuid}>
                <RowTableCell>{lot.lot_number}</RowTableCell>
                <RowTableCell>{lot.block_number || '-'}</RowTableCell>
                <RowTableCell>{lot.cadastral_number || '-'}</RowTableCell>
                <RowTableCell>{projectsMap[lot.uuid]?.name || '-'}</RowTableCell>
                <RowTableCell>{getLotStatusLabel(lot.status)}</RowTableCell>
                <RowTableCell sx={{ textAlign: 'center' }}>
                  <ActionIconButton
                    variant="edit"
                    onClick={() => onEdit(lot)}
                    disabled={!canEditLots}
                  />
                  <ActionIconButton
                    variant="delete"
                    onClick={() => onDelete(lot)}
                    disabled={!canEditLots}
                  />
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={6} message="No se encontraron lotes" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default LotsTableView;
